import { ReactNode } from 'react';
import { Grid } from '@mui/material';
import { FederalHoliday } from 'types';
import { useTranslation } from 'react-i18next';
import HolidayAutocomplete from 'components/autocompletes/HolidayAutocomplete';
import ViolationsAutocomplete from 'components/autocompletes/ViolationsAutocomplete';
import EnforcementScheduler from 'components/inputs/EnforcementScheduler';
import EnforcementCalendar from 'components/widgets/EnforcementCalendar';
import SettingsSection from 'components/layout/SettingsSection';
import { RuleTypeFormProps } from './RuleForm';

const TowRuleForm = ({
  rule,
  setRule,
  violations,
  setSchedule,
  handleAutoCompleteChange,
  isMobile,
}: RuleTypeFormProps): ReactNode => {
  const { t } = useTranslation();

  const handleClearSchedule = () => {
    setSchedule({
      sunday: [],
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
    });
  };

  return (
    <>
      <SettingsSection
        title={t('labels.tow_rule_details', { ns: 'rules' })}
        divider={false}
      >
        <Grid container width='100%' spacing={1.5}>
          <Grid size={12}>
            <ViolationsAutocomplete
              selected={rule.data.violations}
              handleChange={handleAutoCompleteChange}
              loading={!rule}
              options={violations}
              required
            />
          </Grid>
        </Grid>
      </SettingsSection>
      <SettingsSection
        title={t('labels.enforcement_schedule', { ns: 'rules' })}
        divider={false}
      >
        <Grid container width='100%' spacing={3}>
          <Grid size={12}>
            <EnforcementScheduler
              hideTitle={true}
              schedule={rule.data.enforcementSchedule}
              setSchedule={setSchedule}
              clearSchedule={handleClearSchedule}
            />
          </Grid>
          <Grid size={12}>
            <EnforcementCalendar
              schedule={rule.data.enforcementSchedule}
              hideTitle={true}
            />
          </Grid>
          <Grid size={12}>
            <HolidayAutocomplete
              holidays={rule.data.holidayExceptions}
              loading={!rule}
              margin={isMobile ? 'normal' : 'dense'}
              setHolidays={(holidays: FederalHoliday[]) => {
                setRule({
                  ...rule,
                  data: { ...rule.data, holidayExceptions: holidays },
                });
              }}
            />
          </Grid>
        </Grid>
      </SettingsSection>
    </>
  );
};

export default TowRuleForm;
